export class BikeDetailsModel {
  constructor(
    id,
    bikeNumber,
    bikeSerialNumber,
    bikeTypeId,
    bikeIcon,
    lock,
    bikeId,
    isSponsored,
    isMissing,
    technicalStatus,
    logisticsStatus,
  ) {
    const lockData = lock || { shackleStateNotificationsEnabled: true };

    this.id = id;
    this.bikeId = bikeId;
    this.bikeNumber = bikeNumber;
    this.bikeTypeId = bikeTypeId || null;
    this.bikeIcon = bikeIcon;
    this.isMissing = isMissing || false;
    this.technicalStatus = technicalStatus;
    this.logisticsStatus = logisticsStatus || "none";
    this.bikeSerialNumber = bikeSerialNumber;
    this.isSponsored = isSponsored || false;
    this.lockImei = lockData.imei;
    this.lockPhoneNumber = lockData.phoneNumber || null;
    this.lockSimSerialNumber = lockData.simSerialNumber || null;
    this.lockType = lockData.type;
    this.shackleStateNotificationsEnabled =
      lockData.shackleStateNotificationsEnabled;
  }
}

export const LockDeviceType = Object.freeze({
  mark1: { value: "mark1", name: "Mark1" },
  mark2: { value: "mark2", name: "Mark2" },
  mark3: { value: "mark3", name: "Mark3" },
  okaiZk105: { value: "okaiZk105", name: "OKAI Zk105" },
  omni: { value: "omni", name: "Omni" },
  m136: { value: "m136", name: "M136" },
  // mark4: { value: "mark4", name: "Mark4 (ROOVEE IoT)" },
  notione: { value: "notione", name: "notiOne" },
  flotaOnline: { value: "flotaOnline", name: "Flota-Online — lokalizator GPS" },
});
